// extracted by mini-css-extract-plugin
module.exports = {"memoryBookIneligible":"memory-book-ineligible_memoryBookIneligible__1s0G7","buttons":"memory-book-ineligible_buttons__zisCX","content":"memory-book-ineligible_content__3feI-"};